/**
 * `kind: 'press'`, a buzzer. Sends only `true`: order is the server's `receivedAt`, never
 * a client timestamp. `pointerdown` fires as the thumb lands; `preventDefault` stops a
 * synthetic click, double-tap zoom or text selection.
 */

import type { InputSpec } from '@gsf/contract';
import type { RendererProps } from '../renderer';

export function PressInput({
  spec,
  submit,
  disabled,
}: RendererProps<Extract<InputSpec, { kind: 'press' }>>) {
  return (
    <button
      type="button"
      className={`buzzer${disabled ? '' : ' is-armed'}`}
      disabled={disabled}
      onPointerDown={(event) => {
        event.preventDefault();
        if (disabled) return;
        navigator.vibrate?.(60);
        submit(true);
      }}
    >
      {spec.label}
    </button>
  );
}
